import cn from 'classnames';

const TabList: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
  return (
    <div className={cn('tab-list', className)}>
      <ul>{children}</ul>
    </div>
  );
};

TabList.displayName = 'TabList';

export default TabList;
